import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { CallerAddress, CallerAddressInput } from '@/models/caller';

export const createCallerAddress = async (data: CallerAddressInput): Promise<CallerAddress> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation CreateCallerAddress($data: CallerAddressInputType!) {
        createCallerAddress(data: $data) {
          id
          name
          streetAddress
          streetAddress2
          city
          state
          zip
          country
          latitude
          longitude
          order
          noteToDriver
          gourmetNoteToDriver
          phoneNumber
          isAirport
          googlePlaceId
          isApproved
        }
      }
    `),
    variables: {
      data,
    },
  });

  return response.data?.createCallerAddress!;
};
